// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f6c6e94a","732":"6c507b64","977":"3e9869a4"}[chunkId] + ".chunk.js";
};